import { render, staticRenderFns } from "./BCardActionsContainer.vue?vue&type=template&id=be04f81c&"
import script from "./BCardActionsContainer.vue?vue&type=script&lang=js&"
export * from "./BCardActionsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be04f81c')) {
      api.createRecord('be04f81c', component.options)
    } else {
      api.reload('be04f81c', component.options)
    }
    module.hot.accept("./BCardActionsContainer.vue?vue&type=template&id=be04f81c&", function () {
      api.rerender('be04f81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/components/b-card-actions/BCardActionsContainer.vue"
export default component.exports